/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Scan_FullInputs */



/**
* | output |
* | --- |
* | "Card scanner" |
*
* @param {Nav_Scan_FullInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const nav_scan_full = /** @type {((inputs?: Nav_Scan_FullInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Scan_FullInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Kartenscanner")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Scanner de cartes")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("卡牌扫描")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("卡牌掃描器")
	if (locale === "ko") return /** @type {LocalizedString} */ ("카드 스캐너")
	return /** @type {LocalizedString} */ ("Card scanner")
});